import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { FactorCompletion, FactorCompletionFieldType } from '@app/models/analysis.model';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RubricComponent } from '../rubric-card/rubric-card.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-result-card',
    standalone: true,
    imports: [CommonModule, MatIconModule, MatCardModule, RubricComponent],
    templateUrl: './result-card.component.html',
    styleUrls: ['./result-card.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('collapsed', style({ height: '0px', opacity: '0' })),
            state('expanded', style({ height: '*', opacity: '1' })),
            transition('collapsed <=> expanded', animate('300ms ease-in-out')),
        ]),
    ],
})
export class ResultCardComponent {
    @Input() factor!: FactorCompletion;
    @ViewChild('expandContent') expandContent!: ElementRef;

    isExpanded = false;

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer
    ) {
        this.matIconRegistry.addSvgIcon(
            'attention',
            this.domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/attention.svg')
        );
    }

    get feedback() {
        return 'It appears that a response to this rubric aspect was not found in the compatible files you submitted.';
    }

    toggleExpand(): void {
        this.isExpanded = !this.isExpanded;
    }

    get expandState() {
        return this.isExpanded ? 'expanded' : 'collapsed';
    }
}
